import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import { PrivacyIcon, SupportIcon, termsIcon } from "./icons";

export const sideBarData = [
  {
    icon: ChatBubbleOutlineOutlinedIcon,
    label: "Chat",
    options: [],
    screenName: "chat",
  },
  {
    icon: ShoppingCartOutlinedIcon,
    label: "Shop",
    options: [],
    screenName: "book",
  },
  {
    icon: BookmarkBorderOutlinedIcon,
    label: "Trips",
    options: [],
    screenName: "myTrips",
  },
];

export const sideBarSubData = [
  {
    icon: SupportIcon,
    label: "Support",
    options: [],
  },
  {
    icon: PrivacyIcon,
    label: "Privacy Policy",
    options: [],
  },
  {
    icon: termsIcon,
    label: "Terms of Service",
    options: [],
  },
];
